(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["duration-price-helper"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('duration-price-helper')) {
    class DurationPriceHelper extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section, dialog');
        if (!this.section) return;
        this.section.addEventListener('variant:update', this.onVariantUpdate);
      }

      disconnectedCallback() {
        if (this.section) {
          this.section.removeEventListener('variant:update', this.onVariantUpdate);
        }
      }

      onVariantUpdate = (event) => {
        const detail = event.detail || {};
        const data = detail.data || {};

        if (data.newProduct && data.newProduct.id) {
          this.dataset.productId = data.newProduct.id;
        } else if (event.target instanceof HTMLElement && event.target.dataset.productId && event.target.dataset.productId !== this.dataset.productId) {
          return;
        }

        const html = data.html;
        if (!html) return;

        const selector = 'duration-price-helper[data-block-id="' + this.dataset.blockId + '"]';
        const next = html.querySelector(selector);
        const currentPill = this.querySelector('.duration-price-helper__pill');
        const nextPill = next ? next.querySelector('.duration-price-helper__pill') : null;

        if (nextPill && currentPill) {
          currentPill.replaceWith(nextPill);
        } else if (nextPill && !currentPill) {
          this.appendChild(nextPill);
        } else if (!nextPill && currentPill) {
          currentPill.remove();
        }
      };
    }

    customElements.define('duration-price-helper', DurationPriceHelper);
  }
  } catch(e) { console.error(e); }
})();

})();
